import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { marketStockExchangeSlice } from '!views/Market/StockExchange/_marketStockExchange.slice';
import { TrlNoDataFeedback } from '»components/atoms';
import { uuidSelector } from '»components/Auth';
import {
  TrlCardSmall,
  TrlCardStockExchange,
} from '»components/molecules/TrlCard';

import {
  CardsListContainer,
  MobileCardsListContainer,
} from './TrlCardsList.styles';

export const TrlCardsList = ({
  titles,
  isLoadingTitles,
  footerDetailsHeight,
  maxHeight,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const mosaicListRef = useRef(null);

  const [mosaicListOffsetTop, setMosaicListOffsetTop] = useState(
    mosaicListRef.current?.offsetTop,
  );

  const uuid = useSelector(uuidSelector);

  useEffect(() => {
    if (!isMobile)
      dispatch(marketStockExchangeSlice.actions.webAreaGraphQuotesRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid]);

  useEffect(() => {
    if (mosaicListRef.current)
      setMosaicListOffsetTop(mosaicListRef.current.offsetTop);
  }, []);

  const cardsView = useMemo(() => {
    if (!isLoadingTitles && titles?.length === 0) return <TrlNoDataFeedback />;

    return titles?.map((offerData) => {
      if (isMobile)
        return (
          <TrlCardStockExchange
            key={offerData.id}
            data={offerData}
            isCardMobileList
          />
        );

      return <TrlCardSmall key={offerData.id} data={offerData} />;
    });
  }, [isLoadingTitles, isMobile, titles]);

  if (isMobile)
    return <MobileCardsListContainer>{cardsView}</MobileCardsListContainer>;

  return (
    <CardsListContainer
      id="titlesViewCardsContainer"
      ref={mosaicListRef}
      maxHeight={
        maxHeight ||
        (mosaicListRef.current
          ? window.innerHeight -
            mosaicListOffsetTop -
            (footerDetailsHeight || 0)
          : 'unset')
      }
    >
      {cardsView}
    </CardsListContainer>
  );
};

TrlCardsList.propTypes = {
  titles: PropTypes.array,
  isLoadingTitles: PropTypes.bool,
  footerDetailsHeight: PropTypes.number,
  maxHeight: PropTypes.string,
};
